export default "__VITE_ASSET__C3vi85cx__"